import Participation from '../domain/Participation';

export function getTotalCapacity(participations: Participation[]): number {
  return participations.reduce((acc, curr) => acc + +curr.capacity, 0);
}
